<template>
  <component :is="currentComponentName" class="cms-components" v-bind="$attrs" v-on="$listeners" :currentComponentName="componentsName" />
</template>

<script>
/** 主题 cms 图片组件 */
const CmsImage  = resolve => import('./components/cms-image').then(resolve);
/** 主题 cms 标题组件 */
const CmsTitle  = resolve => import('./components/cms-title').then(resolve);
/** 主题 cms 优惠券组件 */
const CmsCoupon  = resolve => import('./components/cms-coupon').then(resolve);
/** 主题 cms 商品组件 */
const CmsGoods  = resolve => import('./components/cms-goods').then(resolve);
/** 主题 cms 门店组件 */
const CmsStore  = resolve => import('./components/cms-store').then(resolve);

/** 主题 cms 轮播图 */
const CmsSwipe  = resolve => import('./components/cms-swipe').then(resolve);
/** 主题 cms 金刚区 */
const CmsTextNav  = resolve => import('./components/cms-text-nav').then(resolve);
/** 主题 cms 广告 */
const CmsSlidingBlock  = resolve => import('./components/cms-sliding-block').then(resolve);
/** 劵包 */
const CmsSuperCoupon  = resolve => import('./components/cms-super-coupon').then(resolve);
export default {
  components: {
    CmsImage, CmsTitle, CmsCoupon, CmsGoods, CmsStore, CmsSwipe, CmsTextNav, CmsSlidingBlock,
    CmsSuperCoupon
  },
  name: 'cms-components',
  props: {
    //  cms 模型名称
    componentsName: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    componentsNameMap() {
      return {
        //  主题 cms 图片组件
        cmsImage: "CmsImage",
        //  主题 cms 标题
        cmsTitle: "CmsTitle",
        //  主题 cms 优惠券组件
        cmsCoupon: 'CmsCoupon',
        //  主题 cms 商品组件
        cmsGoods: 'CmsGoods',
        //  主题 cms 门店组件
        cmsStore: 'CmsStore',
        //  主题 cms 轮播图
        cmsSwipe: 'CmsSwipe',
        //  主题 cms 金刚区
        cmsTextNav: 'CmsTextNav',
        //  主题 cms 广告区
        cmsSlidingBlock: 'CmsSlidingBlock',
        //  劵包
        cmsSuperCoupon: 'CmsSuperCoupon',
      };
    },
    currentComponentName() {
      return this.componentsNameMap[this.componentsName];
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cms-components {
    font-size: 0;
  }
</style>
